module.exports = __webpack_public_path__ + "img/1698343544127.51a22b8c.jpg";